export default {
  'menu.list.searchTable': 'Search Table',
  'menu.gift.searchTable': '礼物列表',
  'searchTable.form.number': 'Set Number',
  'searchTable.form.number.placeholder': 'Please enter Set Number',
  'searchTable.form.name': 'Set Name',
  'searchTable.form.name.placeholder': 'Please enter Set Name',
  'searchTable.form.contentType': 'Content Type',
  'searchTable.form.contentType.img': 'image-text',
  'searchTable.form.contentType.horizontalVideo': 'Horizontal short video',
  'searchTable.form.contentType.verticalVideo': 'Vertical short video',
  'searchTable.form.filterType': 'Filter Type',
  'searchTable.form.filterType.artificial': 'artificial',
  'searchTable.form.filterType.rules': 'Rules',
  'searchTable.form.createdTime': 'Create Date',
  'searchTable.form.status': '状态',
  'searchTable.form.status.1': '已上线',
  'searchTable.form.status.0': '已下线',
  'searchTable.form.search': 'Search',
  'searchTable.form.reset': 'Reset',
  'searchTable.form.selectDefault': 'All',
  'searchTable.operation.create': 'Create',
  'searchTable.operation.import': 'Import',
  'searchTable.operation.download': 'Download',
  // columns
  'searchTable.columns.id': '礼物编号',
  'searchTable.columns.name': '礼物名称',
  'searchTable.columns.price': '礼物价格',
  'searchTable.columns.image': '礼物图片',
  'searchTable.columns.status': '状态',
  'searchTable.columns.operations': '操作',
  'searchTable.columns.operations.view': '查看',
};
